<h2 mat-dialog-title>Configure Lab Order Settings</h2>

<mat-dialog-content>
    <p *ngIf="!isUpdatingOtherUser">Lab orders require a Lancet Code for your user profile.</p>
    <p *ngIf="isUpdatingOtherUser && targetUser">
        Lab orders require a Lancet Code for <strong>{{ targetUser.title }} {{ targetUser.name }} {{ targetUser.surname }}</strong>.
    </p>

    <form [formGroup]="configForm" class="config-form">
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Lancet Code</mat-label>
            <input matInput formControlName="lancetCode" 
                   [placeholder]="isUpdatingOtherUser ? 'Enter Lancet Code for ' + targetUser?.name : 'Enter your Lancet Code'"
                   [disabled]="!isDoctor && !isUpdatingOtherUser">
            <mat-hint *ngIf="!isDoctor && !isUpdatingOtherUser">Only available for doctors. Please contact your administrator to set your Lancet Code.</mat-hint>
            <mat-hint *ngIf="(isDoctor || isUpdatingOtherUser) && data.needsLancetCode">Required for lab order submission</mat-hint>
            <mat-error *ngIf="configForm.get('lancetCode')?.hasError('required')">
                Lancet Code is required for lab order submission
            </mat-error>
        </mat-form-field>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end" class="p-10">
    <button mat-button (click)="cancel()">Cancel</button>
    <button mat-raised-button color="primary" (click)="save()" [disabled]="configForm.invalid || isSaving">
        <mat-icon *ngIf="isSaving">hourglass_empty</mat-icon>
        <span>{{ isSaving ? 'Saving...' : 'Save' }}</span>
    </button>
</mat-dialog-actions>